import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-header card-p border-0 pt-0" }
const _hoisted_8 = { class: "card-title align-items-start flex-column" }
const _hoisted_9 = { class: "card-label fw-bolder fs-3" }
const _hoisted_10 = { class: "card-body p-0" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_13 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_14 = { class: "menu-item-wrapper" }
const _hoisted_15 = { class: "menu-item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_17 = { class: "menu-item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.readOnly)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Select, {
              name: "priceGroup",
              target: "priceGroup",
              label: _ctx.$t('message.PRICE_GROUP'),
              placeholder: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.PRICE_GROUP')}`,
              priceGroup: _ctx.priceGroup,
              "onUpdate:priceGroup": _cache[1] || (_cache[1] = ($event: any) => (_ctx.priceGroup = $event)),
              selectData: _ctx.priceGroups,
              value: _ctx.priceGroup,
              callEmit: true,
              clearable: true,
              filterable: true,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePriceGroup(_ctx.priceGroup)))
            }, null, 8, ["label", "placeholder", "priceGroup", "selectData", "value"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Input, {
              type: "number",
              name: "specialPrice",
              label: `${_ctx.$t('message.SPECIAL_PRICE')}`,
              specialPrice: _ctx.specialPrice,
              "onUpdate:specialPrice": _cache[3] || (_cache[3] = ($event: any) => (_ctx.specialPrice = $event)),
              target: "specialPrice",
              value: _ctx.specialPrice
            }, null, 8, ["label", "specialPrice", "value"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "mt-2 btn-custom",
              disabled: _ctx.priceGroupBtn,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addPriceGroup())),
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.priceGroupId == undefined ? _ctx.$t('message.SAVE') : _ctx.$t('message.UPDATE')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("h3", _hoisted_8, [
            _createVNode("span", _hoisted_9, _toDisplayString(`${_ctx.$t('message.PRICE_GROUPS')} ${_ctx.$t('message.LIST')}`), 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Table, {
              columns: _ctx.readOnly ? _ctx.columns.filter(column => column.key != 'actions') : _ctx.columns,
              rows: _ctx.groupsList,
              pagination: _ctx.pagination,
              padding: 5,
              onHandleCurrentChange: _ctx.handleCurrentChange,
              loading: _ctx.loader
            }, {
              "cell-name": _withCtx(({row:item}) => [
                _createTextVNode(_toDisplayString(item?.price_group?.name), 1)
              ]),
              "cell-actions": _withCtx(({row:item, index:index}) => [
                (!_ctx.isWmsRecord(item?.price_group))
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("div", _hoisted_15, [
                            _createVNode("a", {
                              onClick: ($event: any) => (_ctx.handleEdit(index)),
                              class: "menu-link me-1"
                            }, [
                              _hoisted_16,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                            ], 8, ["onClick"])
                          ]),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("a", {
                              onClick: ($event: any) => (_ctx.handleDelete(index)),
                              class: "menu-link me-1"
                            }, [
                              _hoisted_18,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                            ], 8, ["onClick"])
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
          ])
        ])
      ])
    ])
  ]))
}